// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Accordion from "../../../../../library/hooks/Accordion.bs.js";
import * as SuspensionGuideTableCmp from "./SuspensionGuideTableCmp.bs.js";
import * as SuspensionGuideHeaderCmp from "./SuspensionGuideHeaderCmp.bs.js";

function SuspensionGuideCmp(Props) {
  var index = Props.index;
  var thresholds = Props.thresholds;
  var action_value = Props.action_value;
  var max_score = Props.max_score;
  var title_text = Props.title_text;
  var table_details = Props.table_details;
  var match = Accordion.useAccordion(undefined);
  return React.createElement("div", {
              className: "suspension-guide-container" + (
                Curry._1(match[0], index) ? " active" : ""
              )
            }, React.createElement(SuspensionGuideHeaderCmp.make, {
                  title_text: title_text,
                  index: index,
                  accordionOnClick: match[1]
                }), React.createElement(SuspensionGuideTableCmp.make, {
                  thresholds: thresholds,
                  action_value: action_value,
                  max_score: max_score,
                  table_details: table_details
                }));
}

var make = SuspensionGuideCmp;

export {
  make ,
  
}
/* react Not a pure module */
